export default __webpack_public_path__ + "static/media/001-south africa.9d35f522.svg";